

import { TrendingUpRounded } from "@material-ui/icons";
import Async from "../../components/Async";

const AuthGuard = Async(() => import('../auth.guard'));

const routes = {
    growthDashboard: {
        id: 'growthDashboard',
        name: 'Growth Dashboard',
        icon: <TrendingUpRounded />,
        path: 'https://growth.facilitajuridico.com',
        roles: ['growth_report'],
        isLink: true,
        isHandshake: true,
        handshakeService: 'admin/dashboard-token',
        handshakeTargetUrl: 'https://growth.facilitajuridico.com/auth/callback',
        guard: AuthGuard,
    },
}

const pages = Object.values(routes);

export default {
    routes,
    pages
}
